import React, { useState, FC, useContext, useEffect } from 'react';
import { TranslationContext } from '../handlers/TranslationsHandler';

interface ISiteHandler {
  generateCatalogue: boolean;
  setGenerateCatalogue: any;
  loading: boolean;
  setLoading: any;
}

export const SiteContext = React.createContext<ISiteHandler>({} as any);

export const SiteHandler: FC<{ children: any }> = ({ children }) => {
  const [generateCatalogue, setGenerateCatalogue] = useState(false);
  const [loading, setLoading] = useState(false);
  const { translate } = useContext(TranslationContext); //This will access the translation handler

  useEffect(()=> {
    const metaDescriptionTag = document.querySelector("meta[name='description']") as HTMLMetaElement;
    if (metaDescriptionTag) {
      metaDescriptionTag.content = translate("metaDescription"); // Translation based on the selected language
    }
  }, [translate]);

  return (
    <SiteContext.Provider
      value={{ generateCatalogue, setGenerateCatalogue, loading, setLoading }}
    >
      {children}
    </SiteContext.Provider>
  );
};
